import { AdminExamLocationDetailProvider } from '@exam-center/admin-exam-center-location-details';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { useParams } from '@exam-center/router';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function AdminExamCenterLocationDetailLayout() {
  const { roomId } = useParams('/admin/exam-location/locations/:roomId');
  return (
    <PermissionGuard
      requiredPermission={[
        APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION.VIEW,
        APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_USAGE.VIEW,
      ]}
      options={{
        operator: 'OR',
      }}
    >
      <AdminExamLocationDetailProvider examRoomId={roomId}>
        <Outlet />
      </AdminExamLocationDetailProvider>
    </PermissionGuard>
  );
}
